import { Deserializable } from '../protocols/deserializable';
import { FundType } from './fund-type';
import { DonutChartData } from '../../views/shared/components/donut-chart/donut-chart-data';
import { ODataResponse } from '../protocols/odata-response';

export class MemberAccountFundAllocation implements Deserializable {
  public fundId!: number;
  public fund!: FundType;
  // User inputted percentage of users total balance amongst all funds
  public percentageOfTotalBalance!: number;
  // User inputted total balance of this particular fund
  public totalBalance!: number;

  public constructor(fundId: number, fund: FundType, percentageOfTotalBalance: number, totalBalance: number) {
    this.fundId = fundId;
    this.fund = fund;
    this.percentageOfTotalBalance = percentageOfTotalBalance;
    this.totalBalance = totalBalance;
  }

  public onDeserialize() {
    if (this.fund) {
      this.fund = window?.injector?.Deserialize.instanceOf(FundType, this.fund);
    }
  }

  public asDonutChartData(): DonutChartData {
    return {
      label: this.fund.name,
      amount: this.totalBalance,
      percentage: this.percentageOfTotalBalance.toFixed(2),
      color: this.fund.getChartDataColor()
    };
  }

  public isCashFund(): boolean {
    return this.fundId === 1;
  }

  static generateFakes(zeroBalance: boolean = false): ODataResponse<MemberAccountFundAllocation> {
    const fundJson2 = `{
      "fundId": 2,
      "fund": {
         "colour": "#DC3725",
         "id": 2,
         "name": "Balanced"
      },
      "percentageOfTotalBalance": ${zeroBalance ? '0' : '10'},
      "totalBalance":  ${zeroBalance ? '0' : '12305.03'}
    }`;
    const fundJson3 = `{
      "fundId": 3,
      "fund": {
      "colour": "#79B6A7",
         "id": 3,
         "name": "Equity"
      },
      "percentageOfTotalBalance": ${zeroBalance ? '0' : '0'},
      "totalBalance":  ${zeroBalance ? '0' : '0'}
    }`;
    const fundJson4 = `{
      "fundId": 4,
      "fund": {
          "colour": "#03536B",
         "id": 4,
         "name": "Bond"
      },
      "percentageOfTotalBalance": ${zeroBalance ? '0' : '45'},
      "totalBalance":  ${zeroBalance ? '0' : '55372.65'}
    }`;
    const fundJson5 = `{
      "fundId": 5,
      "fund": {
          "colour": "#CF9E3C",
         "id": 5,
         "name": "Money Market"
      },
      "percentageOfTotalBalance": ${zeroBalance ? '0' : '45'},
      "totalBalance":  ${zeroBalance ? '0' : '55372.65'}
    }`;

    const fakeFunds = [fundJson2, fundJson3, fundJson4, fundJson5].map(json => {
      return window?.injector?.Deserialize?.instanceOf(MemberAccountFundAllocation, JSON.parse(json));
    });

    return {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      '@odata.context': '',
      // eslint-disable-next-line @typescript-eslint/naming-convention
      '@odata.count': fakeFunds.length,
      value: fakeFunds
    };
  }
}
